"use client";
import { setLoginParams } from "@/utils/redux/gigya";
import {
  useAppDispatch,
  useAppSelector,
} from "@/utils/hooks/reactUseCustomHooks";
import { useGigya } from "@dxp-feed/gigya";
export const useUpdateStore = () => {
  const dispatch = useAppDispatch();
  const { gigya, isLoaded } = useGigya();
  const userSession = useAppSelector((state) => state.gigyaslice);
  // Function to update store after checking authorization
  const updateStoreIfAuthorized = async (storeNumber: any) => {
    try {
      if (!userSession?.loggedIn || !userSession?.uid) return;
      gigya.accounts.setAccountInfo({
        data: {
          [process.env.NEXT_PUBLIC_HOME_BANNER || ""]: {
            storeId: storeNumber,
          },
        },
        callback: (res: any) => {
          if (res?.data[process.env.NEXT_PUBLIC_HOME_BANNER || ""]) {
            dispatch(
              setLoginParams({
                ...userSession,
                sobeysCom: {
                  ...userSession?.sobeysCom,
                  storeId: storeNumber,
                  bannerCode: userSession?.sobeysCom?.bannerCode || "",
                },
              })
            );
          }
        }
      });
    } catch (error) {
      console.error("Error updating store:", error);
    }
  };

  return { updateStoreIfAuthorized };
};
